import React from "react";
import { Typography } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";

interface FormSectionProps {
  title?: string;
  // Shown under the section title (e.g. gatepass vs SC expiry on visitor details)
  headerError?: string;
  children: React.ReactNode;
  isFullWidth?: boolean;
  button?: React.ReactNode;
  className?: string;
}

const headerErrorHelperSx = {
  ml: 0,
  fontWeight: 500,
  fontSize: 12,
  color: "error.main",
} as const;

const FormSection: React.FC<FormSectionProps> = ({
  title,
  headerError,
  button,
  isFullWidth,
  children,
  className,
}) => {
  const sectionClass = className
    ? className
    : isFullWidth
      ? "grid-cols-1"
      : "grid-cols-1 md:grid-cols-2";

  const renderHeaderContent = () => {
    if (title && button) {
      if (headerError) {
        return (
          <>
            <div className="flex min-w-0 flex-col gap-0.5 py-1">
              <Typography variant="body2">{title}</Typography>
              <FormHelperText error sx={headerErrorHelperSx}>
                {headerError}
              </FormHelperText>
            </div>
            <div className="shrink-0 self-center">{button}</div>
          </>
        );
      }
      // Preserve original title + button layout (GroupMembers, RepeatableField, VehicleDetails, …)
      return (
        <>
          <Typography variant="body2">{title}</Typography>
          {button}
        </>
      );
    }

    if (title) {
      if (headerError) {
        return (
          <div className="flex min-w-0 flex-col gap-0.5 py-1">
            <Typography variant="body2">{title}</Typography>
            <FormHelperText error sx={headerErrorHelperSx}>
              {headerError}
            </FormHelperText>
          </div>
        );
      }
      return <Typography variant="body2">{title}</Typography>;
    }

    return null;
  };

  const headerClassName = headerError
    ? "flex justify-between items-start bg-[#F7F8FA] px-6 min-h-14 py-2"
    : "flex justify-between items-center bg-[#F7F8FA] px-6 h-14";

  return (
    <div className="rounded-lg border border-[#E6EDF2]">
      <div className={headerClassName}>{renderHeaderContent()}</div>
      <div className={`grid py-4 px-6 gap-4 ${sectionClass}`}>{children}</div>
    </div>
  );
};

export default FormSection;
